import { render } from "./CDDetailsContainer.vue?vue&type=template&id=09960084&scoped=true"
import script from "./CDDetailsContainer.vue?vue&type=script&lang=js"
export * from "./CDDetailsContainer.vue?vue&type=script&lang=js"

import "./CDDetailsContainer.vue?vue&type=style&index=0&id=09960084&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09960084"]])

export default __exports__